const exception = require('../exception/index.js');

const update_navigation_size = require('./handler/navigation_size');

//update_inner_css_valuesの呼び出し方に注意
//これはresizeハンドラを返す関数なので関数名ではなく関数呼び出しでないとダメ。

module.exports.update_inner_css_values = (ary_element_info=[]) => {

    let option_handler = new Object();

    option_handler.DOM = new Object();
    option_handler.selector = new Object();
    option_handler.update_handler = new Object();

    let minimum_ary_element_info=[
        ["body",`body`,'must_exist',(option)=>{}],
        //["navigation",`.main-navigation`,'skip_check',update_navigation_size],
    ];

    ary_element_info = ary_element_info.concat(minimum_ary_element_info);

    for(index in ary_element_info){
        let [name,selector,skip_check,update_handler] = ary_element_info[index];
        let DOM_part=document.querySelector(selector);


        if([
            skip_check !== "skip_check",
            DOM_part == null
        ].every((e)=>e)){
            throw new exception.MalformedMarkup(`missing elements name(${name})`);
        }

        if([
            update_handler,
            typeof update_handler !== 'function'
        ].every((e)=>e)){
            throw new exception.InvalidParameter(`invalid update_handler(${name})`);
        }
        
        option_handler.DOM[name]=DOM_part;
        option_handler.selector[name]=selector;
        option_handler.update_handler[name]=update_handler;
    }
    const handle_resize = (first_call=false) => {
        //const ary_width_breakpoint=[720,360,0];

        let viewarea_height = window.innerHeight;
        let viewarea_width = window.innerWidth;

        const update_value = ()=>{
            let DOM_body= option_handler.DOM['body'];
            DOM_body.style.setProperty('--browser-viewarea-height', `${viewarea_height}px`);
            DOM_body.style.setProperty('--browser-viewarea-width', `${viewarea_width}px`);
            DOM_body.style.setProperty('--browser-viewarea-width-no-unit', `${viewarea_width}`);
            DOM_body.style.setProperty('--browser-viewarea-height-no-unit', `${viewarea_height}`);

            //追加でcss変数を更新する
            for(element_name in option_handler.update_handler){
                option_handler.update_handler[element_name](option_handler);
            }
            
        };
        if(first_call){
            update_value();
        } else {
            requestAnimationFrame(update_value);
        }
        
    }
    handle_resize(true);
    return handle_resize;
}
